export default {"src":"/_next/static/media/boy.5f7e7dad.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};